import { IconProps } from "./";
import Icon from "./assets/notification_24.svg";
import { BaseIcon } from "./BaseIcon";

export function Icon24Notification(props: IconProps) {
  return <BaseIcon icon={<Icon />} {...props} />;
}
